// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/build/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import ShoppingOutlined from '/build/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ShoppingOutlined';
export default { SmileOutlined, ShoppingOutlined };
